var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.material_form)?[_c('teaching-materials-form',{attrs:{"material_formProp":_vm.material_form,"edit_id":_vm.edit_id}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }